/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_View_ProfileInputs */

const en_directory_builders_view_profile = /** @type {(inputs: Directory_Builders_View_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View profile`)
};

const zh_directory_builders_view_profile = /** @type {(inputs: Directory_Builders_View_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看资料`)
};

/**
* | output |
* | --- |
* | "View profile" |
*
* @param {Directory_Builders_View_ProfileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_view_profile = /** @type {((inputs?: Directory_Builders_View_ProfileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_View_ProfileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_view_profile(inputs)
	return zh_directory_builders_view_profile(inputs)
});
export { directory_builders_view_profile as "directory.builders.view_profile" }